import type { FormField } from '@cli-types/core-engine/schema.js'
import { DRIZZLE_DEFAULTS } from '@cli-constants/schema.js'
import { assertSupportedFormFieldTree } from '@core-engine/schema/type-mappers/validation/assert-supported-form-field-tree.js'
import { assertSupportedFormFieldType } from '@core-engine/schema/type-mappers/validation/assert-supported-form-field-type.js'
export { DRIZZLE_DEFAULTS }

export function formFieldToDrizzleType(field: FormField, requiredImports: Set<string>): string {
  assertSupportedFormFieldTree(field)

  switch (field.type) {
    case 'text':
      requiredImports.add('varchar')
      return field.maxLength
        ? `varchar({ length: ${field.maxLength} })`
        : `varchar({ length: ${DRIZZLE_DEFAULTS.VARCHAR_LENGTH} })`
    case 'textarea':
      requiredImports.add('text')
      return 'text()'
    case 'email':
      requiredImports.add('varchar')
      return `varchar({ length: ${DRIZZLE_DEFAULTS.VARCHAR_LENGTH} })`
    case 'phone':
      requiredImports.add('varchar')
      return 'varchar({ length: 50 })'
    case 'number':
      requiredImports.add('integer')
      return 'integer()'
    case 'url':
      requiredImports.add('varchar')
      return 'varchar({ length: 500 })'
    case 'date':
      requiredImports.add('date')
      return "date({ mode: 'string' })"
    case 'select':
    case 'radio':
    case 'timezone':
      requiredImports.add('varchar')
      return `varchar({ length: ${DRIZZLE_DEFAULTS.VARCHAR_LENGTH} })`
    case 'checkbox':
      if (field.options && field.options.length > 0) {
        requiredImports.add('jsonb')
        return 'jsonb().$type<string[]>()'
      }
      requiredImports.add('boolean')
      return 'boolean()'
    case 'multiselect':
      requiredImports.add('jsonb')
      return 'jsonb().$type<string[]>()'
    case 'list':
      requiredImports.add('jsonb')
      if (field.fields && field.fields.length > 0) {
        for (const nestedField of field.fields) {
          assertSupportedFormFieldType(nestedField)
        }
        return 'jsonb().$type<Record<string, unknown>[]>()'
      }
      return 'jsonb().$type<string[]>()'
    case 'file':
    case 'upload':
      requiredImports.add('text')
      return 'text()'
    default:
      requiredImports.add('text')
      return 'text()'
  }
}
